import {
  validateVendorTopCategoriesByClickRequest,
  validateVendorTopProductsClickRequest,
  validateVendorTrafficRequest,
} from "./schemas/vendorStatsSchemas";
import { vendorStatsProvider } from "./providers/vendorStats";

function buildTopProductsPayload(validated) {
  const payload = {};
  if (validated.vendorListId != null) payload.vendorListId = validated.vendorListId;
  if (validated.startDate) payload.startDate = validated.startDate;
  if (validated.endDate) payload.endDate = validated.endDate;
  if (validated.categoryListId != null) payload.categoryListId = validated.categoryListId;
  if (validated.catalogListId != null) payload.catalogListId = validated.catalogListId;
  if (validated.limit != null) payload.limit = validated.limit;
  return payload;
}

function buildTrafficPayload(validated) {
  const payload = {};
  if (validated.vendorListId != null) payload.vendorListId = validated.vendorListId;
  if (validated.resolution) payload.resolution = validated.resolution;
  const hasRange = Boolean(validated.startDate && validated.endDate);
  if (hasRange) {
    payload.startDate = validated.startDate;
    payload.endDate = validated.endDate;
  } else if (validated.limit != null) {
    payload.limit = validated.limit;
  }
  return payload;
}

function buildCategoriesPayload(validated) {
  const payload = {};
  if (validated.vendorListId != null) payload.vendorListId = validated.vendorListId;
  if (validated.startDate) payload.startDate = validated.startDate;
  if (validated.endDate) payload.endDate = validated.endDate;
  if (validated.limit != null) payload.limit = validated.limit;
  return payload;
}

const vendorStatsService = {
  getTopProductsByClick: async (request) => {
    const validated = validateVendorTopProductsClickRequest(request);
    const payload = buildTopProductsPayload(validated);
    const data = await vendorStatsProvider.getTopProductsByClick(payload);
    const items = [...(data.items ?? [])].sort((a, b) => (b.clickCount ?? 0) - (a.clickCount ?? 0));
    return { ...data, items };
  },

  getVendorTraffic: async (request) => {
    const validated = validateVendorTrafficRequest(request);
    const payload = buildTrafficPayload(validated);
    return vendorStatsProvider.getVendorTraffic(payload);
  },

  getTopCategoriesByClick: async (request) => {
    const validated = validateVendorTopCategoriesByClickRequest(request);
    const payload = buildCategoriesPayload(validated);
    const data = await vendorStatsProvider.getTopCategoriesByClick(payload);
    const items = [...(data.items ?? [])].sort((a, b) => (b.clickCount ?? 0) - (a.clickCount ?? 0));
    return { ...data, items };
  },
};

export default vendorStatsService;
